// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.resources-page {
    min-height: 1538px;

    padding-top: 50px;
}

.content-section {

    max-width: 600px;
    /* Adjust the maximum width as needed */
    margin: 0 auto;
    /* Center the text block on the page */
    padding: 40px;
    /* Add some padding for breathing space */
    font-family: 'Arial', sans-serif;
    /* Choose a suitable font */
    font-size: 16px;
    /* Adjust the font size as needed */
    line-height: 1.5;
    /* Set the line height for better readability */
    color: #333;
    /* Set the text color */
    background-color: #ffffffde !important;
    /* Set a light background color */
    border-radius: 8px;
    /* Add rounded corners */
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    /* Add a subtle box shadow */
    margin-bottom: 100px;
    margin-top: 100px;
    font-weight: 500;
    text-align: left;
    text-decoration: none;
}

.content-section2 {
    max-width: 600px;
    /* Adjust the maximum width as needed */
    margin: 0 auto;
    /* Center the text block on the page */
    padding: 20px;
    /* Add some padding for breathing space */
    font-family: 'Arial', sans-serif;
    /* Choose a suitable font */
    font-size: 16px;
    /* Adjust the font size as needed */
    line-height: 1.5;
    /* Set the line height for better readability */
    color: #333;
    /* Set the text color */
    background-color: #f8f8f8dd;
    /* Set a light background color */
    border-radius: 8px;
    /* Add rounded corners */
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    /* Add a subtle box shadow */
    margin-bottom: 100px;
    margin-top: 100px;
    text-align: left;
    text-decoration: none;
}

.content-section a {
    color: #971d1d;
}

.content-section2 a {
    color: #971d1d;
}

.important-text {
    font-size: 19px;
}

.thickLine {
    border: 2px solid #969696;
    /* Set the border style, color, and width */
    margin: 20px 0;
    border-radius: 3px;
    /* Add some spacing above and below the line */
}

.thickLine2 {
    border: 3px solid #FF3131;
    /* Set the border style, color, and width */
    margin: 20px 0;
    border-radius: 3px;
    /* Add some spacing above and below the line */
}

.thinLine {
    border: 2px solid #FF3131;
    /* Set the border style, color, and width */
    margin: 20px 0;
    border-radius: 2px;
    float: left;
    width: 50%;
    /* Add some spacing above and below the line */
    display: inline-block;
}

.logo-title {
    padding-left: 8px;

}

.image-links1 {
    max-height: 70px;
    margin-top: 0px;
    margin-bottom: 0px;


    transition: all .2s ease-in-out;

}

.image-links2 {
    max-height: 50px;
    margin-top: 0px;
    margin-bottom: 0px;


    transition: all .2s ease-in-out;

}

.image-links3 {
    max-height: 90px;
    margin-top: 0px;
    margin-bottom: 0px;


    transition: all .2s ease-in-out;

}

.image-links1:hover {
    max-height: 70px;
    margin-top: 0px;
    margin-bottom: 0px;


    transform: scale(1.1);

}

.image-links2:hover {
    max-height: 50px;
    margin-top: 0px;
    margin-bottom: 0px;


    transform: scale(1.1);

}

.image-links3:hover {
    max-height: 120px;
    margin-top: 0px;
    margin-bottom: 0px;


    transform: scale(1.1);

}

.image-links3:hover {
    max-height: 90px;
    margin-top: 0px;
    margin-bottom: 0px;


    transform: scale(1.1);

}

.logoandtextline {
    display: flex;
    /* Use Flexbox to control layout */
    align-items: center;
    /* Center items vertically */
    gap: 15px;
}

.AOS-custom {
    padding-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Resources.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;;IAElB,iBAAiB;AACrB;;AAEA;;IAEI,gBAAgB;IAChB,uCAAuC;IACvC,cAAc;IACd,sCAAsC;IACtC,aAAa;IACb,yCAAyC;IACzC,gCAAgC;IAChC,2BAA2B;IAC3B,eAAe;IACf,mCAAmC;IACnC,gBAAgB;IAChB,+CAA+C;IAC/C,WAAW;IACX,uBAAuB;IACvB,sCAAsC;IACtC,iCAAiC;IACjC,kBAAkB;IAClB,wBAAwB;IACxB,uCAAuC;IACvC,4BAA4B;IAC5B,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,uCAAuC;IACvC,cAAc;IACd,sCAAsC;IACtC,aAAa;IACb,yCAAyC;IACzC,gCAAgC;IAChC,2BAA2B;IAC3B,eAAe;IACf,mCAAmC;IACnC,gBAAgB;IAChB,+CAA+C;IAC/C,WAAW;IACX,uBAAuB;IACvB,2BAA2B;IAC3B,iCAAiC;IACjC,kBAAkB;IAClB,wBAAwB;IACxB,uCAAuC;IACvC,4BAA4B;IAC5B,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,2CAA2C;IAC3C,cAAc;IACd,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA;IACI,yBAAyB;IACzB,2CAA2C;IAC3C,cAAc;IACd,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA;IACI,yBAAyB;IACzB,2CAA2C;IAC3C,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,8CAA8C;IAC9C,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;;AAErB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;;;IAGlB,+BAA+B;;AAEnC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;;;IAGlB,+BAA+B;;AAEnC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;;;IAGlB,+BAA+B;;AAEnC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;;;IAGlB,qBAAqB;;AAEzB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;;;IAGlB,qBAAqB;;AAEzB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;;;IAGlB,qBAAqB;;AAEzB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;;;IAGlB,qBAAqB;;AAEzB;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,mBAAmB;IACnB,4BAA4B;IAC5B,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB","sourcesContent":[".resources-page {\n    min-height: 1538px;\n\n    padding-top: 50px;\n}\n\n.content-section {\n\n    max-width: 600px;\n    /* Adjust the maximum width as needed */\n    margin: 0 auto;\n    /* Center the text block on the page */\n    padding: 40px;\n    /* Add some padding for breathing space */\n    font-family: 'Arial', sans-serif;\n    /* Choose a suitable font */\n    font-size: 16px;\n    /* Adjust the font size as needed */\n    line-height: 1.5;\n    /* Set the line height for better readability */\n    color: #333;\n    /* Set the text color */\n    background-color: #ffffffde !important;\n    /* Set a light background color */\n    border-radius: 8px;\n    /* Add rounded corners */\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    /* Add a subtle box shadow */\n    margin-bottom: 100px;\n    margin-top: 100px;\n    font-weight: 500;\n    text-align: left;\n    text-decoration: none;\n}\n\n.content-section2 {\n    max-width: 600px;\n    /* Adjust the maximum width as needed */\n    margin: 0 auto;\n    /* Center the text block on the page */\n    padding: 20px;\n    /* Add some padding for breathing space */\n    font-family: 'Arial', sans-serif;\n    /* Choose a suitable font */\n    font-size: 16px;\n    /* Adjust the font size as needed */\n    line-height: 1.5;\n    /* Set the line height for better readability */\n    color: #333;\n    /* Set the text color */\n    background-color: #f8f8f8dd;\n    /* Set a light background color */\n    border-radius: 8px;\n    /* Add rounded corners */\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    /* Add a subtle box shadow */\n    margin-bottom: 100px;\n    margin-top: 100px;\n    text-align: left;\n    text-decoration: none;\n}\n\n.content-section a {\n    color: #971d1d;\n}\n\n.content-section2 a {\n    color: #971d1d;\n}\n\n.important-text {\n    font-size: 19px;\n}\n\n.thickLine {\n    border: 2px solid #969696;\n    /* Set the border style, color, and width */\n    margin: 20px 0;\n    border-radius: 3px;\n    /* Add some spacing above and below the line */\n}\n\n.thickLine2 {\n    border: 3px solid #FF3131;\n    /* Set the border style, color, and width */\n    margin: 20px 0;\n    border-radius: 3px;\n    /* Add some spacing above and below the line */\n}\n\n.thinLine {\n    border: 2px solid #FF3131;\n    /* Set the border style, color, and width */\n    margin: 20px 0;\n    border-radius: 2px;\n    float: left;\n    width: 50%;\n    /* Add some spacing above and below the line */\n    display: inline-block;\n}\n\n.logo-title {\n    padding-left: 8px;\n\n}\n\n.image-links1 {\n    max-height: 70px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n\n\n    transition: all .2s ease-in-out;\n\n}\n\n.image-links2 {\n    max-height: 50px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n\n\n    transition: all .2s ease-in-out;\n\n}\n\n.image-links3 {\n    max-height: 90px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n\n\n    transition: all .2s ease-in-out;\n\n}\n\n.image-links1:hover {\n    max-height: 70px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n\n\n    transform: scale(1.1);\n\n}\n\n.image-links2:hover {\n    max-height: 50px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n\n\n    transform: scale(1.1);\n\n}\n\n.image-links3:hover {\n    max-height: 120px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n\n\n    transform: scale(1.1);\n\n}\n\n.image-links3:hover {\n    max-height: 90px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n\n\n    transform: scale(1.1);\n\n}\n\n.logoandtextline {\n    display: flex;\n    /* Use Flexbox to control layout */\n    align-items: center;\n    /* Center items vertically */\n    gap: 15px;\n}\n\n.AOS-custom {\n    padding-bottom: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
